exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ld-over{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: rgba(0,0,0,0.3);\n    z-index: 9999;\n}\n.ld-over-img {\n    margin: auto;\n    position: absolute;\n    left: 40%;\n    top : 20%;\n}\n", ""]);

// exports
